<script lang="ts">
  import DirectUploader from '../../utils/direct-uploader'

  let {
    id = "direct-upload-file-input",
    class: classNames = "",
    imageChanged = () => {}, // the local image changed
    uploadChanged = () => {}, // the uploaded file changed
    uploadError = () => {}, // the uploaded file errored
    mimeTypes = "image/*",
    multiple = false,
  } = $props()

  let fileInput: HTMLInputElement | null = null
  let uploadProgress: Record<string, number> = $state({})
  let totalFiles = $state(0)
  const uploadPercent = $derived.by(() => {
    return Object.values(uploadProgress).reduce((acc, value) => acc + value, 0) / totalFiles
  })

  function fileInputChanged() {
    if (!fileInput || !fileInput.files?.[0]) return

    totalFiles = fileInput.files.length

    Array.from(fileInput.files).forEach((file, i) => {
      const meta = {
        file,
        currentFile: i + 1,
        totalFiles,
      }
      const reader = new FileReader()
      reader.onload = (evt) => {
        imageChanged(evt.target.result, meta)
      }
      reader.readAsDataURL(file)

      const uploader = new DirectUploader(
        file,
        {
          onProgress,
          onComplete,
          onError,
          meta,
        }
      )
      uploader.process()
    })
  }

  function onProgress(event, meta) {
    if (event.lengthComputable) {
      uploadProgress[meta.currentFile] = Math.round((event.loaded / event.total) * 100)

      const allStarted = Object.keys(uploadProgress).length === totalFiles
      const allDone = Object.values(uploadProgress).every(value => value >= 100);

      // hides the progress bar when done
      if (allStarted && allDone) {
        window.setTimeout(() => {
          uploadProgress = {}
        }, 3000)
      }
    }
  }

  function onComplete(blob, meta) {
    uploadChanged(blob, meta)
  }

  function onError(error, meta) {
    uploadChanged(null, meta)
    uploadError(error, meta)
  }
</script>

<input
  {id}
  type="file"
  class="form-control {classNames}"
  bind:this={fileInput}
  onchange={fileInputChanged}
  accept={mimeTypes}
  {multiple}
/>

{#if uploadPercent > 0}
  <div class="progress">
    <div
      class="progress-bar progress-bar-success progress-bar-striped active"
      role="progressbar"
      aria-valuenow="60"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: {uploadPercent}%;">
      <span>{uploadPercent}% Complete</span>
    </div>
  </div>
{/if}

<style>
  .progress {
    margin-top: .5em;
  }
</style>
